<template>
    <div>
        <div v-for="(item) in menuTree" :key="item.id">
            <!-- 思路: 有子元素使用el-submenu 没有子元素使用el-menu-item -->
            <el-submenu :index="item.menuUrl?item.menuUrl+'':'/'" v-if="item.children&&item.children.length>0">
                <template slot="title">
                    <i :class="item.menuIcon"></i>
                    <span slot="title">{{item.menuName}}</span>
                </template>
                <Menu :menuTree="item.children"></Menu>
            </el-submenu>
            <el-menu-item :index="item.menuUrl?item.menuUrl+'':'/'" v-else>
                <i :class="item.menuIcon"></i>
                <span slot="title">{{item.menuName}}</span>
            </el-menu-item>
        </div>
    </div>
</template>
<script>
export default {
    name:"Menu",
    props:{
      menuTree:{
          type:Array,
          default:function(){return []}
      } 
    },
    data(){
        return{
        }
    },
    created(){
    },
    methods:{
    }
}
</script>